import React from "react";
import { CheckCircle, Clock, PauseCircle, XCircle } from "lucide-react";

const StatusIcon = ({ status }) => {
  const getStatusConfig = (status) => {
    switch (status) {
      case "Completed":
        return {
          icon: CheckCircle,
          color: "text-emerald-500",
          bg: "bg-emerald-50",
          border: "border-emerald-200",
          pulse: false,
        };
      case "In Progress":
        return {
          icon: Clock,
          color: "text-blue-500",
          bg: "bg-blue-50",
          border: "border-blue-200",
          pulse: true,
        };
      case "On Hold":
        return {
          icon: PauseCircle,
          color: "text-amber-500",
          bg: "bg-amber-50",
          border: "border-amber-200",
          pulse: false,
        };
      case "Cancelled":
        return {
          icon: XCircle,
          color: "text-red-500",
          bg: "bg-red-50",
          border: "border-red-200",
          pulse: false,
        };
      default:
        return {
          icon: Clock,
          color: "text-gray-500",
          bg: "bg-gray-50",
          border: "border-gray-200",
          pulse: false,
        };
    }
  };

  const config = getStatusConfig(status);
  const IconComponent = config.icon;

  return (
    <div
      className={`inline-flex items-center justify-center w-8 h-8 rounded-xl ${config.bg} ${config.border} border transition-all duration-200`}
    >
      <IconComponent
        className={`h-4 w-4 ${config.color} ${
          config.pulse ? "animate-pulse" : ""
        }`}
      />
    </div>
  );
};

export default StatusIcon;
